import { ca } from '@cian/analytics';

import { TMapNewpageExtra } from '../../../node/utils/analytics';
import { TJsonQuery } from '../../../packages/JsonQuery';

export const trackMapShow = ({
  jsonQuery,
  offersCount,
  mlSearchSessionGuid,
}: {
  jsonQuery: TJsonQuery;
  offersCount: number | undefined;
  mlSearchSessionGuid?: string | null;
}) => {
  const extra: TMapNewpageExtra = { mlSearchSessionGuid: undefined };

  if (mlSearchSessionGuid) {
    extra.mlSearchSessionGuid = mlSearchSessionGuid;
  }

  ca('eventSite', {
    event: 'newpage',
    name: 'newpage',
    category: 'page',
    action: 'newpage',
    label: 'open',
    page: {
      pageType: 'Map',
      siteType: 'mobile',
      offersQty: offersCount ?? null,
      extra,
    },
    sc: jsonQuery,
  });
};
